export default __webpack_public_path__ + "f844306c511fef2ff4d7a2dbb0842298.mp3";